<template>
  <div>
    <div class="rounded-lg text-center">
      <div class="rounded-lg" style="background-color: rgba(63, 81, 181, 0.8); color: white;">
        <h1 class="ml-4 pt-2">Diagnóstico de Hábitos Lectores</h1>
      </div>

      <v-card flat class="my-4 mx-4 pa-4">
        <v-card-text class="text-center ">
          <h3>Intrucciones: En la siguiente encuesta, necesitamos obtener información acerca de tus hábitos lectores y tu actitud hacia la lectura. No hay respuestas buenas ni malas, solo necesitamos conocer tu opinión sincera sobre los temas que estamos consultando. Por favor, selecciona la opción que más te representa en las siguientes preguntas. ¡Muchas gracias por tu participación!</h3>
        </v-card-text>
      </v-card>
    </div>

    <v-row v-if="loading" justify="center" align="center" style="height: 80vh">
      <v-col cols="12" class="text-center">
        <v-progress-circular size="80" width="5" color="primary" indeterminate></v-progress-circular>
        <div class="mt-4 text-h6">Cargando...</div>
      </v-col>
    </v-row>
    
    <v-card  v-if="!loading" flat class="mt-4 pa-4 scrollable-content--large">
      <template >
        <v-card v-for="(question, index) in questions"
          :key="'question-'+question.id"
          class="mb-6 "
        >
          <v-card-title class="white--text book-paragraph primary">
            <v-icon left color="white">mdi-comment-question</v-icon>
            {{ `Pregunta ${index + 1}: ${question.text}` }}
            <v-spacer></v-spacer>
            <div class="question-status">
              <v-chip :color="getQuestionStatusColor(question.id)"
                      dark>
                      {{ questionStatuses[question.id] ? 'Respondida' : 'Pendiente' }}
              </v-chip>
            </div>
            
          </v-card-title>

          <v-card-text>
            <!-- Single Choice -->
            <div v-if="question.type === 'single_choice'" class="options-container">
              <v-radio-group v-model="studentReply[question.id].answerId" @change="handleSingleChoiceChange(question.id)">
                <v-radio
                  v-for="option in question.options"
                  :key="`option-${question.id}-${option.id}`"
                  :value="option.id"
                  color="success"
                >
                  <template v-slot:label>
                    <span >{{ option.text }}</span>
                  </template>
                </v-radio>
              </v-radio-group>
            </div>

            <!-- Multiple Choice -->
            <div v-if="question.type === 'multiple_choice'" class="options-container">
              <div >
                  Seleccione {{ question.max_selections }} opciones
              </div>
              <div >
                  {{ selectionCounter(question.id) }} de {{ question.max_selections }} seleccionadas
              </div>
              <v-checkbox
                  v-for="option in question.options"
                  :key="`moption-${question.id}-${option.id}`"
                  :label="option.text"
                  :value="option.id"
                  v-model="studentReply[question.id].answerId"
                  :disabled="isOptionDisabled(question.id, option.id)"
                  @change="handleMultipleChoiceChange(question.id)"
                  color="success"
                  class="custom-checkbox"
                  >
                  <template v-slot:label>
                      <span :class="{
                      'selected-option': isChecked(question.id, option.id),
                      'disabled-option': isOptionDisabled(question.id, option.id)
                      }">
                      {{ option.text }}
                      </span>
                  </template>
              </v-checkbox>
              </div>

            <!-- Matrix -->
            <div v-if="question.type === 'matrix'" class="matrix-container">
              <v-table class="matrix-table">
              <thead>
                  <tr >
                  <th class="subquestion-header"></th>
                  <th 
                      v-for="option in question.options" 
                      :key="`header-${question.id}-${option.id}`"
                      class="option-header"
                  >
                      {{ option.text }}
                  </th>
                  </tr>
              </thead>
              <tbody>
                  <tr 
                  v-for="sub in question.sub_questions" 
                  :key="`row-${question.id}-${sub.id}`"
                  
                  >
                  <td class="subquestion-cell">{{ sub.text }}</td>
                  <td 
                      v-for="option in question.options" 
                      :key="`cell-${question.id}-${sub.id}-${option.id}`"
                      class="option-cell"
                  >
                      <v-radio-group 
                      v-model="studentReply[question.id].answerId[sub.id]"
                      @change="handleMatrixChange(question.id, sub.id, $event)"
                      class="radio-group"
                      >
                      <v-radio 
                          :value="option.id" 
                          color="success"
                          
                      >
                          <template v-slot:label>
                          <span :class="{
                              'selected-option': studentReply[question.id].answerId[sub.id] === option.id,
                          }">
                              {{ option.text }}
                          </span>
                          </template>
                      </v-radio>
                      </v-radio-group>
                  </td>
                  </tr>
              </tbody>
              </v-table>
          </div>
            <!-- Open Question -->
            <v-textarea
              v-if="question.type === 'open'"
              v-model="studentReply[question.id].answerText"
              @input="handleAnswerChange(question.id, 'open', $event)"
            ></v-textarea>
          </v-card-text>
        </v-card>
      </template>

      <v-card-actions class="d-flex justify-center sticky-footer">
        <v-btn
          @click="submit"
          x-large
          color="deep-purple accent-4"
          class="white--text"
        >
          Terminar Diagnóstico
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>
  
  <script>
import axios from "axios";
import Swal from "sweetalert2";

export default {
  data() {
    return {
      questions: [],
      studentReply: {},
      loading: true,
      questionStatuses: {}, 
      timeSpent: 0,
      showError: {},
    };
  },
  computed: {
    hasUnansweredQuestions() {
      return Object.values(this.questionStatuses).some(status => !status);
    },
    questionStatusColors() {
      const colors = {};
      Object.keys(this.questionStatuses).forEach(id => {
        colors[id] = this.questionStatuses[id] ? 'green' : 'orange';
      });
      return colors;
    }
  },
  methods: {
    handleSingleChoiceChange(questionId) {
      this.updateQuestionStatus(questionId); // Solo actualiza esta pregunta
      this.saveToLocalStorage();
    },
    handleMultipleChoiceChange(questionId) {
      this.updateQuestionStatus(questionId); // Solo actualiza esta pregunta
      this.saveToLocalStorage();
    },
    handleMatrixChange(questionId, subId, value) {
      this.$set(this.studentReply[questionId].answerId, subId, value);
      this.updateQuestionStatus(questionId); // Solo actualiza esta pregunta
      this.saveToLocalStorage(); // También deberías guardar aquí
    },
    updateQuestionStatus(questionId) {
      const currentStatus = this.questionStatuses[questionId];
        const question = this.questions.find(q => q.id === questionId);
        const reply = this.studentReply[questionId];
        
        if (!question || !reply) {
            if (currentStatus !== false) {
                this.$set(this.questionStatuses, questionId, false);
            }
            return;
        }
        
        let isValid = false;
        
        if (question.type === 'open') {
            isValid = reply.answerText && reply.answerText.trim() !== '';
        } else if (question.type === 'multiple_choice') {
            isValid = reply.answerId && reply.answerId.length === question.max_selections;
        } else if (question.type === 'matrix') {
            isValid = reply.answerId && 
            Object.values(reply.answerId).every(val => val !== null && val !== undefined);
        } else {
            isValid = reply.answerId !== null && reply.answerId !== undefined;
        }
        
        // Solo actualizar si el estado cambió
        if (currentStatus !== isValid) {
            this.$set(this.questionStatuses, questionId, isValid);
        }
    },
    updateAllQuestionStatuses() {
      this.questions.forEach(question => {
        this.updateQuestionStatus(question.id);
      });
    },
    getQuestionStatusColor(questionId) {
      return this.questionStatuses[questionId] ? 'green' : 'orange';
    },
    isChecked(questionId, optionId) {
      return this.studentReply[questionId].answerId.includes(optionId);
    },

    updateMultipleSelection(question, optionId, isChecked) {
      const currentAnswers = [...this.studentReply[question.id].answerId];
      
      if (isChecked) {
        if (currentAnswers.length < question.max_selections) {
          currentAnswers.push(optionId);
        }
      } else {
        const index = currentAnswers.indexOf(optionId);
        if (index > -1) {
          currentAnswers.splice(index, 1);
        }
      }
      
      this.$set(this.studentReply[question.id], 'answerId', currentAnswers);
    },

    isOptionDisabled(questionId, optionId) {
      const currentAnswers = this.studentReply[questionId].answerId;
      const question = this.questions.find(q => q.id === questionId);
      return currentAnswers.length >= question.max_selections && 
            !currentAnswers.includes(optionId);
    },

    selectionCounter(questionId) {
      return this.studentReply[questionId].answerId.length;
    },

    initializeAnswers() {
        this.questions.forEach(question => {
            if (!this.studentReply[question.id]) {
            const baseStructure = { questionId: question.id };
            
            if (question.type === 'multiple_choice') {
                baseStructure.answerId = [];
            } 
            else if (question.type === 'matrix') {
                baseStructure.answerId = {};
                // Inicializar cada subpregunta
                question.sub_questions.forEach(sub => {
                baseStructure.answerId[sub.id] = null;
                });
            } 
            else if (question.type === 'open') {
                baseStructure.answerText = '';
            } 
            else {
                baseStructure.answerId = null;
            }
            
            this.$set(this.studentReply, question.id, baseStructure);
            }
        });
    },

    handleAnswerChange(questionId, type, value) {
      const reply = this.studentReply[questionId] || { questionId: questionId };
      
      if (type === 'multiple_choice') {
        reply.answerId = value;
      }
      else if (type === 'matrix') {
        reply.answerId = { ...reply.answerId, ...value };
      }
      else if (type === 'open') {
        reply.answerText = value;
      }
      else {
        reply.answerId = value;
      }
      
      this.$set(this.studentReply, questionId, reply);
      this.updateQuestionStatus(questionId); // Añadir esta línea
      this.saveToLocalStorage();
    },

    saveToLocalStorage() {
      const data = {
        studentReply: this.studentReply,
        timeSpent: this.timeSpent
      };
      localStorage.setItem(`habitosLectores${this.$route.params.id}`, JSON.stringify(data));
    },

    loadFromLocalStorage() {
      const data = localStorage.getItem(`habitosLectores${this.$route.params.id}`);
      if (data) {
        const parsed = JSON.parse(data);

        Object.keys(parsed.studentReply).forEach(qId => {
          if (this.studentReply[qId]) {
            this.$set(this.studentReply, qId, {
              ...this.studentReply[qId],
              ...parsed.studentReply[qId]
            });
          }
        });
        this.timeSpent = parsed.timeSpent || 0;

      }
    },
    validateForm() {
      this.showError = {};
      let hasError = false;
      
      this.questions.forEach(question => {
        if (!this.questionStatuses[question.id]) {
          this.$set(this.showError, question.id, true);
          hasError = true;
        }
      });
      
      return !hasError;
    },

    startTimer() {
      // Limpiar timer existente
      this.stopTimer();
      
      this.timerInterval = setInterval(() => {
        this.timeSpent ++;
        if (this.timeSpent % 10 === 0) {
            this.saveToLocalStorage();
        }
      }, 1000);
    },

    stopTimer() {
      if (this.timerInterval) {
        clearInterval(this.timerInterval);
        this.timerInterval = null;
        this.saveToLocalStorage();
      }
    },
    async checkExistingReply() {
      try {
          const response = await axios.get(`student/poll_reply/${this.$route.params.id}`);
          console.log(response)
          if (response.data.ok && response.data.reply) {
          // Si hay una respuesta, redirigir al estudiante o mostrar un mensaje
          Swal.fire({
              title: 'Diagnóstico ya completado',
              text: 'Ya has completado este diagnóstico anteriormente.',
              icon: 'info',
          }).then(() => {
              // Opción 2: Redirigir a la lista de diagnosticos
              this.$router.push('/estudiante/asignaturas');
          });
          }
      } catch (error) {
          console.error('Error al verificar respuesta existente:', error);
      }
  },
    async submit() {
        this.stopTimer();

        if (!this.validateForm()) {
          const unansweredCount = Object.values(this.questionStatuses).filter(status => !status).length;
          
          await Swal.fire({
            title: "¡Faltan respuestas!",
            html: `Tienes ${unansweredCount} ${unansweredCount === 1 ? 'pregunta' : 'preguntas'} sin responder`,
            icon: "warning",
            confirmButtonText: "Entendido",
            footer: 'Por favor completa todas las preguntas requeridas'
          });
          
          this.startTimer();
          return;
        }

      try {
        await Swal.fire({
          title: "¿Desea terminar la evaluación?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sí",
          cancelButtonText: "Volver",
        }).then(async (result) => {
          if (result.isConfirmed) {
            await axios.post("student/poll_reply/" + this.$route.params.id  , {
              answer: JSON.stringify(this.studentReply),
              points: 0, // Encuesta
              time: this.timeSpent
            });
            
            Swal.fire("Completada!", "Las respuestas han sido contestadas", "success");
            localStorage.removeItem(`habitosLectores${this.$route.params.id}`);
            this.$router.push('/estudiante/asignaturas');
          }else{
            this.startTimer(); // Corregido: método correcto
          }
        });
      } catch (error) {
        console.error('Error al enviar respuestas:', error);
        Swal.fire("Error", "No se pudieron guardar las respuestas", "error");
      }
    },
    async fetchQuestions() {
      try {
        const response = await axios.get('/questionHabitos');
        this.questions = response.data.questionsBySection[0];
        this.initializeAnswers();
        this.loadFromLocalStorage();
        this.updateAllQuestionStatuses();
        this.startTimer();
      } catch (error) {
        console.error('Error cargando preguntas:', error);
        Swal.fire('Error', 'No se pudieron cargar las preguntas', 'error');
      } finally {
        this.loading = false;
      }
    },
  },
  async created() {
    try {
      await this.checkExistingReply();
      this.loading = true;
      this.fetchQuestions();

    } catch (error) {
      console.error('Error cargando preguntas:', error);
      Swal.fire('Error', 'No se pudieron cargar las preguntas', 'error');
    }
   
  },
  beforeDestroy() {
    this.stopTimer();
  }
};
</script>